import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { OrderDto } from '../../../models/order/dto/order.dto';

export const GAME_ORDERS_QUERY_KEY = (gameId: number) => ['game-orders', gameId];

export const useGetGameOrders = (gameId: number, options?: { enabled?: boolean }) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: GAME_ORDERS_QUERY_KEY(gameId),
        // Admin-only endpoint — callers pass enabled:false for coach roles so
        // the page doesn't fire a query that can only 403.
        // Two independent conditions, and they are not the same question.
        // `options.enabled` expresses ROLE (callers pass false for coaches, who
        // can only ever get a 403); `Number.isInteger(gameId)` expresses
        // PRESENCE. Without the second one, `GameDetailsPage` opened without
        // its `?game=` query pasted `NaN` straight into the path and the API
        // answered 500 (`column "nan" does not exist`) — the same shape as the
        // `courts/NaN/...` issues this dashboard has already produced.
        enabled: (options?.enabled ?? true) && Number.isInteger(gameId),
        queryFn: () => apiClient.fetchApi<OrderDto[], {}>({
            method: 'GET',
            endpoint: `orders/game/${gameId}/admin`
        }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
